




import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Switch, Grid, IconButton, TextField, Tooltip, FormControlLabel, Checkbox, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import {
  nodesActiveItem,
  nodesRemoveActiveItem,
  nodesRemoveActiveItemById,
  nodesRemoveActive
} from '../../../../../reducers/nodes/nodesReducer';
import { CustomTable } from '../../../../common/Tables/CustomTable/CustomTable';
import { NodesOptionsMenu } from '../../../Options/NodesOptionsMenu/NodesOptionsMenu';
import { InventoryColumnSelector } from '../../../../Inventory/InventoryColumnSelector/InventoryColumnSelector';

export const NodesList = ({ data, columns }) => {
  //columnas que se ven por defecto
  const [visibleColumnIds, setVisibleColumnIds] = useState(['select', 'name', 'firmware_version', 'ip', 'serial_number', 'icc', 'last_gateway_connection', 'status_flag', 'eui', 'deleteAndSummary']);
  const displayedColumns = columns.filter(column => visibleColumnIds.includes(column.id));


  const [search, setSearch] = useState('');
  const activeItem = useSelector(state => state.nodes.active);
  const dispatch = useDispatch();
  const totalItems = useSelector(state => state.nodes.nodes)
  const handleSelect = (nodeId, isChecked) => {
    if (isChecked) {
      dispatch(nodesActiveItem({ id: nodeId }));
    } else {
      dispatch(nodesRemoveActiveItemById(nodeId));
    }
  };

  const handleUnSelectAll = () => {
    dispatch(nodesRemoveActive([]));
    dispatch(nodesRemoveActiveItem([]));
  };

  const handleSelectAll = (isChecked) => {
    if (isChecked) {
      filteredData.forEach(node => {
        if (!activeItem.some(item => item.id === node.id)) {
          dispatch(nodesActiveItem({ id: node.id }));
        }
      });
    } else {
      dispatch(nodesRemoveActiveItem());
    }
  };

  const handleInputChange = (event) => {
    setSearch(event.target.value);
  };

  const filteredData = useMemo(() => {
    return data.filter((row) =>
      search.length === 0
        ? true
        : columns.some((column) => {
          const value = row[column.id];
          return value && String(value).toLowerCase().includes(search.toLowerCase());
        })
    );
  }, [data, search, columns]);

  const allSelected = useMemo(() => {
    return filteredData.length > 0 && filteredData.every(node => activeItem.some(item => item.id === node.id));
  }, [filteredData, activeItem]);

  return (
    <Grid container className='animate__animated animate__fadeIn animate__fast'>
      <Grid item sm={5}>
        <TextField
          id="search"
          label="Buscar"
          type="search"
          name="search"
          autoComplete="off"
          value={search}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>

      <Grid item sm={2}>
        <Tooltip title="Eliminar todo">
          <IconButton edge="end" aria-label="delete" onClick={handleUnSelectAll}>
            <DeleteSweepIcon style={{ fontSize: 30 }} />
          </IconButton>
        </Tooltip>
      </Grid>

      <Grid item sm={3} style={{ marginTop: '25px' }} >
        <Typography>
          <strong>{activeItem.length}</strong> / {totalItems.length} Nodos seleccionados
        </Typography>
      </Grid>
      <Grid item sm={2} style={{ marginTop: '25px' }}>
        <InventoryColumnSelector columns={columns} visibleColumns={visibleColumnIds} onChange={setVisibleColumnIds} columnsIgnored={['select', 'deleteAndSummary']} />
      </Grid>
      <Grid item sm={5} style={{ display: 'flex', alignItems: 'center' }}>
        <FormControlLabel
          control={
            <Switch
              checked={allSelected}
              onChange={(event) => handleSelectAll(event.target.checked)}
              color="primary"
            />
          }
          label="Marcar/Desmarcar todos"
        />
      </Grid>

      <Grid item style={{ width: '100%', marginTop: '16px' }}>
        <CustomTable
          rows={filteredData.map((node) => ({
            ...node,
            select: (
              <Checkbox
                checked={activeItem.some(item => item.id === node.id)}
                onChange={(event) => handleSelect(node.id, event.target.checked)}
              />
            ),
            deleteAndSummary: <NodesOptionsMenu id={node.id} />,
          }))}
          columns={displayedColumns}
        />
      </Grid>
    </Grid>
  );
};

NodesList.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};


